import * as React from 'react'
// @ts-ignore
import IconCaret  from '../../assets/caret-down-svg.svg'
import './styles.scss'

export interface IOption {
  value: number
  label: string
  type: string
  rawOption: any
  suboptions: IOption[]
}

interface OwnProps {
  countType: string
  option: IOption
  onChange: (options: IOption[], option: IOption) => void
  initialValues?: any
  isCollapse: boolean
}

export type Props = OwnProps

const IconCaret = ({ style }: any) => (
  <svg
    width="64.000000pt"
    height="64.000000pt"
    viewBox="0 0 64.000000 64.000000"
    preserveAspectRatio="xMidYMid meet"
    style={style}
  >
    <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
       fill="#000000" stroke="none">
      <path d="M12 488 c-7 -7 -12 -19 -12 -28 0 -20 300 -320 320 -320 20 0 320
        301 320 321 0 37 -16 39 -320 39 -217 0 -299 -3 -308 -12z"/>
    </g>
  </svg>
)

const IconLine = () => (
  <svg width="8" height="1" viewBox="0 0 8 1" xmlns="http://www.w3.org/2000/svg">
    <line x1="0.5" y1="0.5" x2="7.5" y2="0.5" stroke="#1F2534" stroke-linecap="round"/>
  </svg>
)

const IconValidate = () => (
  <svg width="9" height="8" viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.66667 7.40091C2.50667 7.40091 2.4 7.34758 2.29333 7.24091L0.16 5.10758C-0.0533333 4.89425 -0.0533333 4.57425 0.16 4.36091C0.373333 4.14758 0.693333 4.14758 0.906667 4.36091L2.66667 6.06758L7.09333 1.16091C7.30667 0.94758 7.62667 0.94758 7.84 1.10758C8.05333 1.32091 8.05333 1.64091 7.89333 1.85425L3.09333 7.18758C2.98667 7.34758 2.82667 7.40091 2.66667 7.40091Z" fill="#1F2534"/>
  </svg>
)

const Selects = (
  options: IOption[] | any,
  selectedElements: IOption[] | any,
  onSelectedElements: (e: React.MouseEvent, select: IOption) => void ) => {
  return options && options?.map((select: IOption, i: number) => {
    const isActive = selectedElements?.some((item: IOption) => item.value === select.value)

    return (
      <div
        key={`${select.value}__${i}`}
        className={`collapsible__select ${(isActive) ? 'collapsible__select--active' : ''}`}
        onClick={(e: React.MouseEvent) => onSelectedElements(e, select)}
      >
        <div className="collapsible__checked">
          { (isActive) ? (
            <IconValidate />
          ) : '' }
        </div>
        <p className="collapsible__checked__label"> {select.label} </p>
      </div>
    )
  })
}

export const CollapsibleWithSelect: React.FC<Required<Props>> = (props) => {
  const { isCollapse = false, initialValues, option } = props
  const [isCollapsed, setCollapsed] = React.useState<boolean>(isCollapse)
  const hasSuboptions = option.suboptions?.length > 0
  let initialElements = []
  if (initialValues) {
    initialElements = hasSuboptions ? initialValues?.suboptions : [initialValues]
  }
  const [selectedElements, setSelectedElements] = React.useState<IOption[]>(initialElements)
  let isCheckedAll = selectedElements?.length === (hasSuboptions ? option.suboptions?.length : 1)
  const isPartialChecked = hasSuboptions && !isCheckedAll && selectedElements?.length > 0
  const isActive = hasSuboptions && (isCheckedAll || isPartialChecked)

  React.useEffect(() => {
    setCollapsed(isCollapse)
  }, [isCollapse])

  const onCollapse = () => {
    setCollapsed(!isCollapsed)
  }

  const onClickCheckedAll = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    const elements = hasSuboptions ? option.suboptions : [option]
    setSelectedElements(!isCheckedAll ? elements : [])
    props.onChange(selectedElements, option)
  }

  const onSelectedElements = (e: React.MouseEvent, select: IOption) => {
    e.stopPropagation()

    let elements: IOption[] = [
      ...(selectedElements || []),
      select,
    ]

    const isSelected = selectedElements?.some((item: any) => item.value === select.value)
    if (isSelected) {
      elements = elements.filter(item => item.value !== select.value)
    }

    if (elements?.length === option.suboptions?.length) {
      select = option
    }

    setSelectedElements(elements)
    props.onChange(selectedElements, select)
  }

  const selectedCountLabel = (): string => {
    if (!isActive) {
      return ''
    }
    const label = selectedElements?.length !== option.suboptions?.length ?
      `${selectedElements?.length}/${option.suboptions?.length}` : `${selectedElements?.length}`
    return `${label} ${props.countType}`
  }

  return (
    <div
      className="collapsible collapsible--select"
      onClick={onCollapse}
    >
      <div className="collapsible__header">
        { hasSuboptions && (
          <div className="collapsible__expand">
            <IconCaret
              style={{ transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0)' }}
            />
          </div>
        )}
        <div
          className="collapsible__checkedAll"
          onClick={(e: React.MouseEvent<HTMLDivElement>) => onClickCheckedAll(e)}
        >
          {isCheckedAll && <IconValidate /> || isPartialChecked && <IconLine />}
        </div>
        <p className="collapsible__label">
          <span>{option.label}{isActive && ' -'}</span>
          <span style={{ fontWeight: 400 }}>{selectedCountLabel()}</span>
        </p>
      </div>
      <div
        className="collapsible__body"
        style={{
          minHeight: '0',
          height: isCollapsed ? `${(option.suboptions?.length * 48 + (option.suboptions?.length - 1) * 8)}px` : 0,
        }}
      >
        { Selects(option.suboptions, selectedElements, onSelectedElements) }
      </div>
    </div>
  )
}
